import wx from "weixin-js-sdk";
import { getSignPackage } from '@/api/api.js'
// 计算底部黑线处高度
export const diffPadd = () => Number(getComputedStyle(document.documentElement).getPropertyValue("--sab").split('p')[0])

// 是否展示padding-bottom  用于兼容底部黑线
export const getShowPadding = () => { return diffPadd() + 'px' == '0px'}


// 时间格式化
export const formatTime = (time, type) => {
  const day = new Date(time)
  const year = day.getFullYear()
  const month = day.getMonth() + 1
  const date = day.getDate()
  const hour = day.getHours()
  const minutes = day.getMinutes()
  const seconds = day.getSeconds()
  if(type == 1){
    return [year, month, date].map(item => item < 10? '0' + item: item).join('-')
  } else if(type == 2){
    return year + '年' + month + '月' + date + '日'
  } else if(type == 3){
    return year + '-' + (month < 10? '0' + month : month)
  }else if(type == 4){
    return [year, month, date].map(item => item < 10? '0' + item: item).join('-') + ' ' + [hour, minutes].map(item => item < 10? '0' + item: item).join(':')
  }else if(type == 5){
    return [year, month, date].map(item => item < 10? '0' + item: item).join('-')
  }else if(type == 6){
    return [year, month, date].map(item => item < 10? '0' + item: item).join('-') + ' ' + [hour, minutes,seconds].map(item => item < 10? '0' + item: item).join(':')
  }
  
}

// 列表
export const getList = async (vm, funct, fundata,type, num = 5) => {
  if(vm.loadFlag) return
  vm.loadFlag = true
  const res = await funct(fundata)
  vm.loadFlag = false
  vm.loading = false
  if(res.code == 1000){
    let dataList = type == 'intergral'?res.data.list:res.data
    if(type == 'intergral'){
      vm.integral = res.data.integral
    }
    if(Array.isArray(res.data)){
      vm.show = true
      vm.finished = true;
      return
    }
    const { data,  total, last_page, current_page,is_meal } = dataList
    //是否有套餐
    if(type == 'historyQuset' || type == 'imitateQuest'){
      vm.is_meal = dataList.is_meal
    }
   
    if(data.length === 0){
      vm.finished = true;
      if(last_page == 1 || !last_page){
        vm.show = true
      }
    }
    if(total > num){
      vm.finishedtext = '没有更多数据了'
    }
    let list = data
    if (current_page > 1) {
      vm.list = [...vm.list, ...list]
    } else {
      vm.list = list;
    }

    if(type == 'shop'){
      vm.list1 = vm.list.filter((item, index)=> index % 2 == 0)
			vm.list2 = vm.list.filter((item, index)=> index % 2 != 0)
    }

    // 如果当前页数 = 总页数，则已经没有数据
    if (parseInt(current_page) === parseInt(last_page)) {
      vm.finished = true;
    }

    // 如果总页数大于当前页码，页码+1
    if (last_page > current_page) {
      vm.page++;
    }
  }else {
    vm.finished = true;
    vm.$toast(res.msg)
  }
    
}


function getTime(vm, time){
  let hour = parseInt(time / 60 / 60)
  let min = parseInt((time - hour * 60 * 60) / 60) 
  let sec = parseInt(time - hour * 60 * 60 - min * 60)
  vm.time = (hour == 0? "": ((hour<10? '0' + hour:hour) + ':')) + (min<10?'0'+min:min) + ":" + (sec<10?'0'+sec:sec)
  return sec
}

// 倒计时
export const downTime = (vm) => {
  let time = '';
  if(vm.$route.query.time_limit){
    time = vm.$route.query.time_limit * 60
    localStorage.getItem('timer') && clearInterval(localStorage.getItem('timer'))
    localStorage.getItem('timer') && localStorage.removeItem('timer')
    localStorage.getItem('time') && localStorage.removeItem('time')
    
  } else {
    time = Number(localStorage.getItem('time'))
  }
  if(vm.$route.query.time_limit == 0 || localStorage.getItem('time') == 0){
    vm.time = '已超时'
    return
  }
    
  getTime(vm, time)
  
  vm.timer = setInterval(()=>{
    
    time = time - 1
    localStorage.setItem('time', time)
    if(time == 0 || time < 0){
      vm.time = '已超时'
      clearInterval(vm.timer)
      localStorage.removeItem('time')
      localStorage.removeItem('timer')
      return
    }
    getTime(vm, time)
    
  }, 1000)
  localStorage.setItem('timer', vm.timer)
}

export const clear =() => {
  localStorage.getItem('timer') && clearInterval(localStorage.getItem('timer'))
  localStorage.getItem('timer') && localStorage.removeItem('timer')
  localStorage.getItem('time') && localStorage.removeItem('time')
}

export const  getConfig =  async () => {
  const res = await getSignPackage({ url: localStorage.getItem('url') })
  if(res.code == 1000){
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      //以下参数后端接口返回
      appId: res.data.appId, // 必填，公众号的唯一标识
      timestamp: res.data.timestamp,  // 必填，生成签名的时间戳
      nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
      signature: res.data.signature, // 必填，签名
      jsApiList: ["onMenuShareAppMessage"] // 必填，需要使用的JS接口列表，所有JS接口列表
    });
  }
}

export function getShare(){
  console.log('getSh')
  return new Promise((resolve, reject)=>{
    wx.ready(function() {
      wx.onMenuShareAppMessage({
       title:'111', // 分享标题
       desc:'111', // 分享描述
       link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
       imgUrl: '', // 分享图标
       success() {
        resolve()
       },
       fail(){
        reject()
       }
     });

     wx.error(function(res) {
      reject(res)
      alert("出错了：" + res.errMsg); //这个地方的好处就是wx.config配置错误，会弹出窗口哪里错误，然后根据微信文档查询即可。
    });
     
   });
  })
 
  
 
}



